import { Card, Col, Row, Typography } from "@visa/vds"
import React from "react"
import VsttSubscriptionsAccordion from "./VsttSubscriptionsAccordion"


const ImplementationTestingCard = (props) => {

    return (
        <>
            <Row>
                <Col className="margin-bottom-zero padding-left-0px color-navy">
                    <Typography className="margin-bottom-zero" tag="h2" variant="title" id="implementation_testing_title">Implementation Testing</Typography>
                </Col>
            </Row>
            <Card className="width-full card-dashboard blue-left-line margin-bottom-30px card-shadow ">
                <VsttSubscriptionsAccordion 
                selectedBid={props.selectedBid}
                setPageError={props.setPageError}
                />
            </Card>

        </>
    )
}

export default ImplementationTestingCard